require('./index.scss');

class animationModule {
  constructor() {
    this.Init();
  }

  Init() {
    $('.JS_popup_close').on('click', function() {
      $('.popup').removeClass('show');
      $('.JS_popup_qrcode').removeClass('show');
      $('.JS_popup_pay').addClass('show');
    });

    $('.JS_popup').on('click', function() {
      const src = $(this).find('.img').attr('src');
      const desc = $(this).find('.desc').text();
      const type = $(this).find('.type').text();
      $('.JS_popup_img').attr('src', src);
      $('.JS_popup_desc').text(desc);
      $('.JS_popup_type').text(type);
      $('.JS_popup_pay').addClass('show');
      $('.popup').addClass('show');
    });

    $('.JS_popup_free').on('click', function() {
      const src = $(this).find('.img').attr('src');
      const desc = $(this).find('.desc').text();
      const type = $(this).find('.type').text();
      $('.JS_popup_img').attr('src', src);
      $('.JS_popup_desc').text(desc);
      $('.JS_popup_type').text(type);
      $('.JS_popup_pay').removeClass('show');
      $('.popup').addClass('show');
    });

    $('.JS_popup_pay').on('click', function() {
      $('.JS_popup_qrcode').addClass('show');
    });

    $('.JS_popup_qrcode').on('click', function() {
      $('.JS_popup_qrcode').removeClass('show');
    });
  }
}

new animationModule();


// WEBPACK FOOTER //
// ./jws/views/page/animation/index.js